import { Typography } from "@mui/material";
import Paper from "@mui/material/Paper"
import CustomHr from "../../common/customhr";
import "./filelist.component.scss";


const FileListComponent = () => {
    return <div className="container-fluid">
        <div className="row">
            <Paper className="col-8 offset-2 filelist-parent mt-3 mb-3">
                <h5 className="text-center pt-3 pb-1">
                    FILES AVAILABLE
                    <CustomHr />
                </h5>
                <Typography variant="h6" component={"h6"} sx={{ fontFamily: "Signika", fontWeight: 'bold', fontSize: "0.95rem" }} className="text-center mt-3">
                    {"Work In Progress".toUpperCase()}
                </Typography>
            </Paper>
        </div>
    </div>
}

export default FileListComponent;